import * as React from "react";
import { Link } from "react-router-dom";
import actionTypes from "../../../actions/ActionTypes";
import SearchStore from "../../../stores/SearchStore";
class SearchSidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);
    this.state = {
      nodeTree: [],
      h: window.innerHeight - 142,
      favorites: []
    };
    this.toggleNode = this.toggleNode.bind(this);
    this.resizeH = this.resizeH.bind(this);
    this.onSearchUpdate = this.onSearchUpdate.bind(this);
    this.applyTree = this.applyTree.bind(this);
  }
  componentDidMount() {
    SearchStore.addChangeListener(this.onSearchUpdate);
    this.resizeH();
    window.addEventListener("resize", this.resizeH);
    let adTree = SearchStore.getAdTree();
    if (adTree !== void 0) {
      this.applyTree();
    }
  }
  componentWillUnmount() {
    SearchStore.removeChangeListener(this.onSearchUpdate);
    window.removeEventListener("resize", this.resizeH);
  }
  applyTree() {
    let docCount = SearchStore.getDocCount();
    if (docCount !== 1) {
      let adTree = SearchStore.getAdTree();
      let settings = {
        fav: [],
        favOpen: [],
        ouOpen: [],
        bpOpen: []
      };
      if (settings !== null) {
        settings.fav.forEach((id) => {
          var node1 = adTree.find((n1) => n1.type === "bp" && n1.id === id);
          if (node1) {
            node1.isFav = true;
            if (settings.favOpen.indexOf(node1.id) > -1) {
              node1.isOpen = true;
            }
          } else {
            adTree.forEach((ou) => {
              if (ou.type === "ou") {
                var node2 = ou.children.find(
                  (n2) => n2.type === "bp" && n2.id === id
                );
                if (node2) {
                  node2.isFav = true;
                  if (settings.favOpen.indexOf(node2.id) > -1) {
                    node2.isOpen = true;
                  }
                }
              }
            });
          }
        });
        settings.ouOpen.forEach((id) => {
          adTree.forEach((ou) => {
            if (ou.type === "ou") {
              ou.isOpen = true;
            }
          });
        });
        this.setState({
          nodeTree: adTree
          //, favorites: favTree
        });
        this.loadFirstStep(adTree);
      }
    }
  }
  onSearchUpdate() {
    let lastAction = SearchStore.getLastAction();
    if (lastAction === actionTypes.SearchByValues || lastAction === actionTypes.SearchQuickSearch) {
      let docCount = SearchStore.getDocCount();
      if (docCount !== 1) {
        let adTree = SearchStore.getAdTree();
        let settings = {
          fav: [],
          favOpen: [],
          ouOpen: [],
          bpOpen: []
        };
        adTree.forEach((bp) => {
          bp.isOpen = true;
          if (bp.children !== void 0) {
            bp.children.forEach((child) => {
              child.isOpen = true;
            });
          }
        });
        if (settings !== null) {
          settings.fav.forEach((id) => {
            var node1 = adTree.find((n1) => n1.type === "bp" && n1.id === id);
            if (node1) {
              node1.isFav = true;
              if (settings.favOpen.indexOf(node1.id) > -1) {
                node1.isOpen = true;
              }
            } else {
              adTree.forEach((ou) => {
                if (ou.type === "ou") {
                  var node2 = ou.children.find(
                    (n2) => n2.type === "bp" && n2.id === id
                  );
                  if (node2) {
                    node2.isFav = true;
                    if (settings.favOpen.indexOf(node2.id) > -1) {
                      node2.isOpen = true;
                    }
                  }
                }
              });
            }
          });
          settings.ouOpen.forEach((id) => {
            adTree.forEach((ou) => {
              if (ou.type === "ou") {
                ou.isOpen = true;
              }
            });
          });
          this.setState({
            nodeTree: adTree
            //, favorites: favTree
          });
          this.loadFirstStep(adTree);
        }
      }
    }
    if (lastAction === actionTypes.SearchByFieldValue) {
      let docCount = SearchStore.getDocCount();
      if (docCount !== 1) {
        let adTree = SearchStore.getAdTree();
        let settings = {
          fav: [],
          favOpen: [],
          ouOpen: [],
          bpOpen: []
        };
        if (settings !== null) {
          settings.fav.forEach((id) => {
            var node1 = adTree.find((n1) => n1.type === "bp" && n1.id === id);
            if (node1) {
              node1.isFav = true;
              if (settings.favOpen.indexOf(node1.id) > -1) {
                node1.isOpen = true;
              }
            } else {
              adTree.forEach((ou) => {
                if (ou.type === "ou") {
                  var node2 = ou.children.find(
                    (n2) => n2.type === "bp" && n2.id === id
                  );
                  if (node2) {
                    node2.isFav = true;
                    if (settings.favOpen.indexOf(node2.id) > -1) {
                      node2.isOpen = true;
                    }
                  }
                }
              });
            }
          });
          settings.ouOpen.forEach((id) => {
            adTree.forEach((ou) => {
              if (ou.type === "ou") {
                ou.isOpen = true;
              }
            });
          });
          this.setState({
            nodeTree: adTree
            //, favorites: favTree
          });
          this.loadFirstStep(adTree);
        }
      }
    }
    if (lastAction === actionTypes.SearchByUserAudit) {
      console.log("AuditSearch");
      let docCount = SearchStore.getDocCount();
      if (docCount !== 1) {
        let adTree = SearchStore.getAdTree();
        let settings = {
          fav: [],
          favOpen: [],
          ouOpen: [],
          bpOpen: []
        };
        if (settings !== null) {
          settings.fav.forEach((id) => {
            var node1 = adTree.find((n1) => n1.type === "bp" && n1.id === id);
            if (node1) {
              node1.isFav = true;
              if (settings.favOpen.indexOf(node1.id) > -1) {
                node1.isOpen = true;
              }
            } else {
              adTree.forEach((ou) => {
                if (ou.type === "ou") {
                  var node2 = ou.children.find(
                    (n2) => n2.type === "bp" && n2.id === id
                  );
                  if (node2) {
                    node2.isFav = true;
                    if (settings.favOpen.indexOf(node2.id) > -1) {
                      node2.isOpen = true;
                    }
                  }
                }
              });
            }
          });
          settings.ouOpen.forEach((id) => {
            adTree.forEach((ou) => {
              if (ou.type === "ou") {
                ou.isOpen = true;
              }
            });
          });
          this.setState({
            nodeTree: adTree
            //, favorites: favTree
          });
          this.loadFirstStep(adTree);
        }
      }
    }
    if (lastAction === actionTypes.SearchByUserQueue) {
      let docCount = SearchStore.getDocCount();
      if (docCount !== 1) {
        let adTree = SearchStore.getAdTree();
        let settings = {
          fav: [],
          favOpen: [],
          ouOpen: [],
          bpOpen: []
        };
        if (settings !== null) {
          settings.fav.forEach((id) => {
            var node1 = adTree.find((n1) => n1.type === "bp" && n1.id === id);
            if (node1) {
              node1.isFav = true;
              if (settings.favOpen.indexOf(node1.id) > -1) {
                node1.isOpen = true;
              }
            } else {
              adTree.forEach((ou) => {
                if (ou.type === "ou") {
                  var node2 = ou.children.find(
                    (n2) => n2.type === "bp" && n2.id === id
                  );
                  if (node2) {
                    node2.isFav = true;
                    if (settings.favOpen.indexOf(node2.id) > -1) {
                      node2.isOpen = true;
                    }
                  }
                }
              });
            }
          });
          settings.ouOpen.forEach((id) => {
            adTree.forEach((ou) => {
              if (ou.type === "ou") {
                ou.isOpen = true;
              }
            });
          });
          this.setState({
            nodeTree: adTree
            //, favorites: favTree
          });
          this.loadFirstStep(adTree);
        }
      }
    }
    if (lastAction === actionTypes.SearchByNotes || lastAction === actionTypes.SearchByProperties) {
      let docCount = SearchStore.getDocCount();
      if (docCount !== 1) {
        let adTree = SearchStore.getAdTree();
        let settings = {
          fav: [],
          favOpen: [],
          ouOpen: [],
          bpOpen: []
        };
        if (settings !== null) {
          settings.fav.forEach((id) => {
            var node1 = adTree.find((n1) => n1.type === "bp" && n1.id === id);
            if (node1) {
              node1.isFav = true;
              if (settings.favOpen.indexOf(node1.id) > -1) {
                node1.isOpen = true;
              }
            } else {
              adTree.forEach((ou) => {
                if (ou.type === "ou") {
                  var node2 = ou.children.find(
                    (n2) => n2.type === "bp" && n2.id === id
                  );
                  if (node2) {
                    node2.isFav = true;
                    if (settings.favOpen.indexOf(node2.id) > -1) {
                      node2.isOpen = true;
                    }
                  }
                }
              });
            }
          });
          settings.ouOpen.forEach((id) => {
            adTree.forEach((ou) => {
              if (ou.type === "ou") {
                ou.isOpen = true;
              }
            });
          });
          this.setState({
            nodeTree: adTree
            //, favorites: favTree
          });
          this.loadFirstStep(adTree);
        }
      }
    }
  }
  //   onReceiveActiveDocChange() {
  //     let lastChange = ActiveDocumentStore.lastChange();
  //     if (lastChange === actionTypes.ADGetADTree) {
  //       let adTree = ActiveDocumentStore.getADTree();
  //       var settings = this.getADSettings();
  //       var favTree = this.state.favorites;
  //       if (settings !== null) {
  //         settings.fav.forEach((id) => {
  //           var node1 = adTree.find((n1) => n1.type === 'bp' && n1.id === id);
  //           if (node1) {
  //             node1.isFav = true;
  //             if (settings.favOpen.indexOf(node1.id) > -1) {
  //               node1.isOpen = true;
  //             }
  //             favTree.push(node1);
  //           } else {
  //             // search children
  //             adTree.forEach((ou) => {
  //               if (ou.type === 'ou') {
  //                 var node2 = ou.children.find(
  //                   (n2) => n2.type === 'bp' && n2.id === id
  //                 );
  //                 if (node2) {
  //                   node2.isFav = true;
  //                   if (settings.favOpen.indexOf(node2.id) > -1) {
  //                     node2.isOpen = true;
  //                   }
  //                   favTree.push(node2);
  //                 }
  //               }
  //             });
  //           }
  //         });
  //         settings.ouOpen.forEach((id) => {
  //           adTree.forEach((ou) => {
  //             if (ou.type === 'ou') {
  //               ou.isOpen = true;
  //             }
  //           });
  //         });
  //         this.setState({
  //           nodeTree: adTree,
  //           favorites: favTree,
  //         });
  //       }
  //     }
  //   }
  refreshNode(node) {
  }
  loadFirstStep(adTree) {
    if (adTree.length > 0 && adTree[0].type === "bp") {
      var bpId = adTree[0].id;
      if (adTree[0].children.length > 0) {
        var id = adTree[0].children[0].id;
        adTree[0].children[0].isOpen = true;
      }
    }
    if (adTree.length > 0 && adTree[0].type === "ou") {
      if (adTree[0].children.length > 0 && adTree[0].children[0].type === "bp") {
        var bpId = adTree[0].children[0].id;
        if (adTree[0].children.length > 0 && adTree[0].children[0].children.length > 0) {
          var id = adTree[0].children[0].children[0].id;
          adTree[0].children[0].children[0].isOpen = true;
          adTree[0].children[0].isOpen = true;
          adTree[0].isOpen = true;
        }
      }
    }
  }
  resizeH() {
    this.setState({ h: window.innerHeight - 142 });
  }
  copyNode(node) {
    var newNode = {
      id: node.id,
      type: node.type,
      name: node.name,
      isOpen: false,
      isFav: node.isFav,
      count: node.count,
      children: []
    };
    node.children.forEach((n) => {
      newNode.children.push(this.copyNode(n));
    });
    return newNode;
  }
  getADSettings() {
    var settings = JSON.parse(localStorage.getItem("ADSettings"));
    if (settings === null) {
      settings = {
        fav: [],
        favOpen: [],
        ouOpen: [],
        bpOpen: []
      };
    }
    return settings;
  }
  toggleNode(node) {
    console.log(node);
    this.props.LoadBPClick(node.id);
    var settings = this.getADSettings();
    if (node.type === "bp") {
      let idx = settings.bpOpen.indexOf(node.id);
      if (idx === -1 && !node.isOpen) {
        settings.bpOpen.push(node.id);
      } else if (idx > -1 && node.isOpen) {
        settings.bpOpen.splice(idx, 1);
      }
    }
    if (node.type === "ou") {
      let idx = settings.ouOpen.indexOf(node.id);
      if (idx === -1 && !node.isOpen) {
        settings.ouOpen.push(node.id);
      } else if (idx > -1 && node.isOpen) {
        settings.ouOpen.splice(idx, 1);
      }
    }
    localStorage.setItem("ADSettings", JSON.stringify(settings));
    var tree = this.state.nodeTree;
    var node1 = tree.find((n1) => n1.type === node.type && n1.id === node.id);
    if (node1) {
      node1.isOpen = !node1.isOpen;
    } else {
      tree.forEach((ou) => {
        if (ou.type === "ou") {
          var node2 = ou.children.find(
            (n2) => n2.type === node.type && n2.id === node.id
          );
          if (node2) {
            node2.isOpen = !node2.isOpen;
          }
        }
      });
    }
    this.setState({ nodeTree: tree });
  }
  toggleFavNode(node) {
    var tree = this.state.favorites;
    var node1 = tree.find((n1) => n1.type === node.type && n1.id === node.id);
    var settings = this.getADSettings();
    var idx = settings.favOpen.indexOf(node.id);
    if (idx === -1 && !node.isOpen) {
      settings.favOpen.push(node.id);
    } else if (idx > -1 && node.isOpen) {
      settings.favOpen.splice(idx, 1);
    }
    localStorage.setItem("ADSettings", JSON.stringify(settings));
    if (node1) {
      node1.isOpen = !node1.isOpen;
    } else {
      tree.forEach((ou) => {
        if (ou.type === "ou") {
          var node2 = ou.children.find(
            (n2) => n2.type === node.type && n2.id === node.id
          );
          if (node2) {
            node2.isOpen = !node2.isOpen;
          }
        }
      });
    }
    this.setState({ favorites: tree });
  }
  nodeMouseUp(e) {
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column pt-3 ps-3 text-white bg-dark",
        style: { maxHeight: "100%", width: "320px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Search",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement(
          "i",
          {
            style: { color: "#4BB5CF" },
            className: "fa-solid fa-search"
          }
        ), "   ", "Advanced Search")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      this.props.Loading && /* @__PURE__ */ React.createElement("div", { className: "h-100 d-flex flex-column align-items-center justify-content-center" }, /* @__PURE__ */ React.createElement("div", { style: { color: "#8DF5F5", marginBottom: "8px" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-circle-notch fa-3x fa-spin" })), /* @__PURE__ */ React.createElement("div", { style: { color: "#8DF5F5", fontSize: "14pt", fontFamily: 'Tilt Neon, "Courier New", monospace' } }, "Running Search...")),
      !this.props.Loading && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "pe-3 coolScroll",
          style: { maxHeight: `${this.state.h}px`, overflow: "auto" }
        },
        /* @__PURE__ */ React.createElement("ul", { className: "list-group active-documents" }, /* @__PURE__ */ React.createElement("li", { className: "list-group-item d-flex justify-content-between aligh-items-start" }, /* @__PURE__ */ React.createElement("div", { className: "me-auto" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-search" }), " ", /* @__PURE__ */ React.createElement("strong", null, "Search Results"), " ", /* @__PURE__ */ React.createElement("i", { className: "redo-icon fa-solid fa-redo" }))), this.state.nodeTree.map((node) => /* @__PURE__ */ React.createElement(React.Fragment, { key: node.id + 100 }, node.type === "ou" && /* @__PURE__ */ React.createElement(React.Fragment, { key: node.id }, /* @__PURE__ */ React.createElement("li", { className: "list-group-item d-flex justify-content-between aligh-items-start" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "me-auto",
            onClick: () => this.toggleNode(node)
          },
          node.isOpen && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-caret-down" }),
          !node.isOpen && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-caret-right" }),
          " ",
          /* @__PURE__ */ React.createElement(
            "i",
            {
              className: "orgUnit-icon fa-solid fa-folder"
            }
          ),
          " ",
          node.name
        ), /* @__PURE__ */ React.createElement("span", { className: "badge bg-success rounded-pill" }, node.count)), node.isOpen && /* @__PURE__ */ React.createElement("div", { className: "ms-3" }, node.children.map((child) => /* @__PURE__ */ React.createElement(React.Fragment, { key: child.id }, /* @__PURE__ */ React.createElement("li", { className: "list-group-item d-flex justify-content-between aligh-items-start" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "me-auto",
            onClick: () => this.toggleNode(child)
          },
          child.isOpen && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-caret-down" }),
          !child.isOpen && /* @__PURE__ */ React.createElement(
            "i",
            {
              className: "fa-solid fa-caret-right"
            }
          ),
          " ",
          child.name
        ), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: "badge bg-success rounded-pill" }, child.count))), child.isOpen && /* @__PURE__ */ React.createElement("div", { className: "ms-3" }, /* @__PURE__ */ React.createElement("ul", { className: "list-group active-documents" }, child.children.map((step) => /* @__PURE__ */ React.createElement(
          "li",
          {
            key: step.id,
            className: "list-group-item d-flex justify-content-between aligh-items-start",
            onClick: (s) => this.props.LoadStepClick(
              step.id,
              child.id
            )
          },
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: "me-auto",
              style: {
                overflow: "hidden",
                textOverflow: "ellipsis"
              }
            },
            step.stepType === "User" && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-user"
              }
            ), " ", step.name),
            step.stepType !== "User" && /* @__PURE__ */ React.createElement("span", { style: { color: "#C1C1C1" } }, /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-cog"
              }
            ), " ", step.name)
          ),
          step.count > 0 && /* @__PURE__ */ React.createElement("span", { className: "badge bg-success rounded-pill" }, step.count)
        )))))))), node.type === "bp" && /* @__PURE__ */ React.createElement(React.Fragment, { key: node.id }, /* @__PURE__ */ React.createElement("li", { className: "list-group-item d-flex justify-content-between aligh-items-start" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "me-auto",
            onClick: () => this.toggleNode(node)
          },
          node.isOpen && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-caret-down" }),
          !node.isOpen && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-caret-right" }),
          " ",
          node.name
        ), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: "badge bg-success rounded-pill" }, node.count))), node.isOpen && /* @__PURE__ */ React.createElement("div", { className: "ms-3" }, /* @__PURE__ */ React.createElement("ul", { className: "list-group active-documents" }, node.children.map((step) => /* @__PURE__ */ React.createElement(
          "li",
          {
            key: step.id,
            className: "list-group-item d-flex justify-content-between aligh-items-start",
            onClick: () => this.props.LoadStepClick(step.id, node.id)
          },
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: "me-auto",
              style: { overflow: "hidden" }
            },
            step.stepType === "User" && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-user" }), " ", step.name),
            step.stepType !== "User" && /* @__PURE__ */ React.createElement("span", { style: { color: "#C1C1C1" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-cog" }), " ", step.name)
          ),
          step.count > 0 && /* @__PURE__ */ React.createElement("span", { className: "badge bg-success rounded-pill" }, step.count)
        ))))))))
      )
    );
  }
}
export default SearchSidebar;
